import * as React from 'react';
import { navigate } from 'router';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import LocationCreatePopup from '~/apps/shared/containers/locations/LocationCreatePopup';


export default function() {
  return (
    <CurrentOrgInjector
      component={LocationCreatePopup}
      onReturn={() => navigate('receiver.admin.locations')}
    />
  );
};
